export function encodeAsFormUrl(obj) {
    const body = [];
    for (const property in obj) {
        const key = encodeURIComponent(property);
        const value = encodeURIComponent(obj[property]);
        body.push(`${key}=${value}`);
    }
    return body.join('&');
}
export function canBeFormUrlEncoded(obj) {
    if (typeof obj !== 'object') {
        return false;
    }
    if (!obj) {
        return false;
    }
    return Object.values(obj).every(isPrimitive);
}
function isPrimitive(val) {
    return (typeof val === 'string' ||
        typeof val === 'number' ||
        typeof val === 'boolean');
}
